import ready, { HTML } from '../../../../src-core/js/utils';
import Rellax from 'rellax';

export default function initRellax() {

  var rellax = new Rellax('.rellax');

}

ready(() => {

  initRellax();

});
